import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { TimesheetCode } from "@app/models/rest/timesheet-code";
import { TimesheetCodeStore } from "@app/services/store/timesheet-code-store";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-timesheet-code-list",
  templateUrl: "./timesheet-code-list.component.html",
  styleUrls: ["./timesheet-code-list.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class TimesheetCodeListComponent
  extends BaseDataTablePageDirective<TimesheetCode>
  implements OnInit
{
  timesheetCodeStore: TimesheetCodeStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    // {
    //   field: 'id',
    //   text: 'ID',
    //   flex: 1,
    //   editor: false
    // },
    {
      field: "code",
      text: "Code",
      flex: 1,
      editor: true
    },
    {
      field: "description",
      text: "Description",
      flex: 3,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const timesheetCodeStore = inject(TimesheetCodeStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      timesheetCodeStore,
      store,
      dialog,
      "TimesheetCode",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.timesheetCodeStore = timesheetCodeStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.add([
      {
        code: "",
        description: ""
      }
    ]);
  }
}
